export const ZENDESK_SCRIPT_URL = `https://static.zdassets.com/ekr/snippet.js`;
export const DEFAULT_DEPARTMENTS_LIST = [
  'Bonus issues allstarcasino', 'Deposit Assistance allstarcasino', 'Extra bonus allstarcasino', 'High Roller promotions allstarcasino',
  'Other issues allstarcasino', 'Reopen account allstarcasino', 'Technical issue allstarcasino', 'Verification process allstarcasino', 'Withdrawal allstarcasino'
];
export const ONLINE_CHAT_COUNTRIES = ['au', 'de', 'ca', 'nz', 'fi', 'at', 'dk', 'ie', 'jp', 'it'];

export const zendeskStag = '84397';

export interface IZendeskUserData {
  name?: string;
  email?: string;
}
